
export const MAP_PROPERTIES = 'MapProperties'
export const CONSTRUCTION_PROJECTS = 'ConstructionProjects'
